export enum EUnitsOfDistance {
    MILES = 'miles',
    KILOMETERS = 'kilometers',
}